export const COOKIE_CONSENT_EVENT = 'cookie-consent-accepted';

// Banners before the separator fix stored 'cookiePolicy=acceptedexpires=…', so match the prefix
export function hasAcceptedCookies(): boolean {
  return /(?:^|;\s*)cookiePolicy=accepted/.test(document.cookie);
}

export function hasAnsweredCookies(): boolean {
  return /(?:^|;\s*)cookiePolicy=/.test(document.cookie);
}

export function acceptCookies(expires: Date) {
  document.cookie = `cookiePolicy=accepted; expires=${expires.toUTCString()}; path=/`;
  window.dispatchEvent(new Event(COOKIE_CONSENT_EVENT));
}

export function subscribeToCookieConsent(onChange: () => void) {
  window.addEventListener(COOKIE_CONSENT_EVENT, onChange);

  return () => window.removeEventListener(COOKIE_CONSENT_EVENT, onChange);
}
